export interface SetWatchlistStatusDTO {
  advertId: string;
  contactId: string;
  statusId: number;
}
